// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"styles-module--contentArea--wYfOs"};